import { ethers } from 'ethers';
export function makeProviderFromChain(chain) {
    const rpcUrl = chain.rpcUrls.default.http[0];
    return new ethers.providers.StaticJsonRpcProvider(rpcUrl, {
        chainId: chain.id,
        name: chain.name,
    });
}
export function makeProviderFromConfig(chain) {
    return new ethers.providers.StaticJsonRpcProvider(chain.rpcUrl, {
        chainId: chain.chainId,
        name: chain?.name ?? '',
    });
}
//# sourceMappingURL=provider-utils.js.map